import { PinIcon as PinOnMapIcon } from "@wags/ui/product-icons.tsx";

import { cn } from "@wags/ui/ui-utils";
import { type ProviderStat, ProviderStatTiles } from "./provider-stat-tiles";
import { ProviderWebsiteLink } from "./provider-website-link";

export type ProviderMetaStat = ProviderStat & { line: string };

export function ProviderMeta({
    location,
    stats,
    website,
    className,
}: {
    location?: string;
    stats: ProviderMetaStat[];
    website?: string;
    className?: string;
}) {
    const dot = <span className="mx-[0.25em] text-doberman-black/30">·</span>;
    const websiteLink = website ? (
        <ProviderWebsiteLink website={website} />
    ) : null;

    if (stats.length >= 2) {
        return (
            <div className={cn("flex flex-col gap-3", className)}>
                {(location || websiteLink) && (
                    <div className="flex items-center text-body-small text-doberman-black/55">
                        {location && (
                            <>
                                <PinOnMapIcon className="mr-1.5 size-4 shrink-0" />
                                {location}
                            </>
                        )}
                        {websiteLink && (
                            <>
                                {location && dot}
                                {websiteLink}
                            </>
                        )}
                    </div>
                )}
                <ProviderStatTiles stats={stats} className="w-full max-w-md" />
            </div>
        );
    }

    const parts = [location, ...stats.map((s) => s.line)].filter(Boolean);
    if (parts.length === 0 && !websiteLink) return null;

    return (
        <div
            className={cn(
                "flex flex-wrap items-center gap-y-1 text-body-small text-doberman-black/55",
                className,
            )}
        >
            {location && <PinOnMapIcon className="mr-1.5 size-4 shrink-0" />}
            {parts.length > 0 && <span>{parts.join(" · ")}</span>}
            {websiteLink && (
                <>
                    {parts.length > 0 && dot}
                    {websiteLink}
                </>
            )}
        </div>
    );
}
